import { VStack, HStack } from "@/shared/ui/primitives";
import { useTranslation } from "react-i18next";
import { motion, AnimatePresence } from "framer-motion";
import { useState } from "react";

const eventImages = ["/images/ceo.png", "/images/instagram.png", "/images/team.png", "/images/swim.png", "/images/mvp.png"];

export const TimelineSection = () => {
	const { t } = useTranslation();
	const [hoveredIndex, setHoveredIndex] = useState<number | null>(null);

	const events = [1, 2, 3, 4, 5];

	return (
		<VStack className="w-full gap-[28px]">
			{/* 제목 */}
			<VStack className="gap-[10px]">
				<h2 className="text-[1.5rem] md:text-[2.25rem] text-ct-strong font-semibold text-center">
					{t("company.timeline.title")}
				</h2>
				<p className="text-lg text-ct-regular font-medium text-center">
					{t("company.timeline.description")}
				</p>
			</VStack>

			{/* 타임라인 */}
			<VStack className="w-full max-w-[800px] gap-[20px] relative">
				{/* 세로 연결선 */}
				<div className="absolute left-[24px] top-[40px] bottom-[40px] w-[2px] bg-ct-weak hidden md:block z-0" />

				{events.map((event, index) => (
					<motion.div
						key={index}
						className="w-full flex"
						initial={{ opacity: 0, x: -30 }}
						whileInView={{ opacity: 1, x: 0 }}
						viewport={{ once: true }}
						transition={{ delay: index * 0.1, duration: 0.5 }}
					>
						<HStack
							className="gap-[20px] items-start w-full"
							onMouseEnter={() => setHoveredIndex(index)}
							onMouseLeave={() => setHoveredIndex(null)}
						>
							{/* 타임라인 점 */}
							<div className="hidden md:flex items-center justify-center w-[48px] h-[48px] rounded-full bg-pm-strong flex-shrink-0 relative z-10">
								<div className="w-[20px] h-[20px] rounded-full bg-ct-elevated" />

								{/* 호버 시 이미지 - 원 왼쪽 */}
								<AnimatePresence>
									{hoveredIndex === index && (
										<motion.div
											className="absolute right-[calc(100%+16px)] top-1/2 -translate-y-1/2 z-20"
											initial={{ opacity: 0, scale: 0.9, x: 8 }}
											animate={{ opacity: 1, scale: 1, x: 0 }}
											exit={{ opacity: 0, scale: 0.9, x: 8 }}
											transition={{ duration: 0.2, ease: "easeOut" }}
										>
											<div className="w-[200px] h-[134px] rounded-[12px] overflow-hidden shadow-lg ring-1 ring-outline">
												<img
													src={eventImages[index]}
													alt={t(`company.timeline.event${event}.title`)}
													className="w-full h-full object-cover"
												/>
											</div>
										</motion.div>
									)}
								</AnimatePresence>
							</div>

							{/* 이벤트 카드 */}
							<VStack className="flex-1 gap-[12px] p-[24px] rounded-[16px] bg-bg-regular items-start transition-colors duration-200 hover:bg-bg-elevated">
								<span className="text-sm text-pm-strong font-semibold">
									{t(`company.timeline.event${event}.date`)}
								</span>
								<h3 className="text-xl text-ct-strong font-semibold">
									{t(`company.timeline.event${event}.title`)}
								</h3>
								<p className="text-md text-ct-regular font-medium">
									{t(`company.timeline.event${event}.description`)}
								</p>
							</VStack>
						</HStack>
					</motion.div>
				))}
			</VStack>
		</VStack>
	);
};
